import { useEventTypes } from "../hooks/useEventTypes.js";
import "react";
import { Skeleton } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Events/shared/EventTypeTitles.tsx
var EventTypeTitles = ({ eventTypeIds, listAll = true }) => {
	const { data, loading } = useEventTypes({ eventTypeIds }, { cacheStrategy: "cache-only" });
	if (!data?.eventTypes && loading) return /* @__PURE__ */ jsx(Skeleton.Text, { chars: 25 });
	if (!data?.eventTypes || !eventTypeIds?.length) return null;
	if (!listAll && data.total > 1) return /* @__PURE__ */ jsxs("div", {
		className: "flex min-w-0 shrink flex-nowrap",
		children: [/* @__PURE__ */ jsx("div", {
			className: "truncate",
			children: data.eventTypes[0].name
		}), /* @__PURE__ */ jsxs("span", {
			className: "text-info pl-xxs min-w-fit flex-1",
			children: ["+", data.total - 1]
		})]
	});
	return /* @__PURE__ */ jsx(Fragment$1, { children: data.eventTypes.map(({ name }) => name).join(", ") });
};
//#endregion
export { EventTypeTitles };

//# sourceMappingURL=EventTypeTitles.js.map